module.exports = __webpack_public_path__ + "static/media/zhariff-bio.fc6c1986.pdf";